import { schema } from 'prose-core'
import { StrongNodeType } from 'prose-core'
import { NodeType } from 'prosemirror-model'

export const isListItem = (nodeTypeToCheck: NodeType | StrongNodeType<any, any> | undefined) =>
  [schema.nodes.list_item, schema.nodes.vote_list_item].includes(nodeTypeToCheck as StrongNodeType<any, any>)
